export default class RapsoError extends Error {
  constructor(data, code, message) {
    super(message || "An unknown error occured");
    this.name = "RapsoError";
    if (code !== undefined) {
      this.code = code;
    }
    if (message !== undefined) {
      this.message = message;
    }
    this.data = data;
    if (!code && !message) {
      this.generateAutomaticErrorCode(data);
    }
  }
  generateAutomaticErrorCode(err_data) {
    this.code = "UNKNOWN_ERROR";
    this.message = "An unknown error occured";
    // Track unicity constraint error
    if (err_data.code && err_data.code === "ALREADY_EXISTS") {
      this.code = "VALIDATION_ERROR";
      this.message = "Unicity constraint error";
      return;
    }

    if (err_data.detail) {
      this.code = err_data.detail;
      return;
    }
    const response = err_data.response;
    if (!response) {
      return;
    }
    // C.C 03/09/26 le SDK REST lève un ResponseError dont .response est une Response
    // fetch, sans .data, là où axios expose .response.data
    if (response.data) {
      if (response.data.code) {
        this.code = response.data.code;
      }
      if (response.data.message) {
        this.message = response.data.message;
      }
      return;
    }
    if (response.status) {
      this.code = `HTTP_${response.status}`;
      this.message = err_data.message || `Request failed with status ${response.status}`;
    }
  }
}

// C.C 22/09/26 le SDK lève un ResponseError dont le corps (erreurs DRF par champ) n'est
// lisible qu'en await response.json(), hors de portée du constructeur synchrone de RapsoError
export const rapsoErrorWithDetails = async (err) => {
  const rapsoError = new RapsoError(err);
  let body = null;
  if (typeof err?.response?.json === "function") {
    body = await err.response.json().catch(() => null);
  }
  if (body && typeof body === "object") {
    rapsoError.details =
      typeof body.detail === "string"
        ? body.detail
        : Object.entries(body)
            .map(([field, messages]) => `${field} : ${[messages].flat().join(" ")}`)
            .join(" | ");
  }
  return rapsoError;
};
